export default "__VITE_ASSET__Dm8r_6SW__"